<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="case_detail_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><a href="/myproject" style="color: rgba(19,20,28,0.6);font-weight: 500;">我的项目</a></el-breadcrumb-item>
          <el-breadcrumb-item><a href="/" style="color: rgba(19,20,28,0.9);font-weight: 700;">项目详情</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="my_project_detail">
        <div class="my_project_detail_title">
          <span class="my_project_detail_title_code">{{orderInfo.project_name}}</span>
          <span class="my_project_detail_title_status">
            <span>项目状态：{{ orderInfo.order_status_desc }}</span>
            <span class="my_project_detail_title_status_desc" v-if="orderInfo.order_status == 8">失败原因：{{ orderInfo.cancel_reason }}</span>
          </span>
        </div>
        <div class="my_project_detail_content">
          <div class="my_project_detail_content_label">
            客户需求信息
          </div>
          <div class="my_project_detail_content_info">
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">需求描述：</div>
              <div class="my_project_detail_content_item_value">
                <div style="word-break: break-all;" v-html="formatRequirement">
                </div>
              </div>
            </div>
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">附件说明：</div>
              <div class="my_project_detail_content_item_value">
                <a class="my_project_detail_content_item_value_file" target="_blank" :href="item.url" :key="key" v-for="(item, key) in annexData">{{item.filename}}</a>
              </div>
            </div>
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">备注：</div>
              <div class="my_project_detail_content_item_value" style="word-break: break-all;">
                {{orderInfo.notes}}
              </div>
            </div>
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">下单时间：</div>
              <div class="my_project_detail_content_item_value">
                {{orderInfo.create_time_str}}
              </div>
            </div>
            <div class="my_project_detail_content_item">
              <div class="my_project_detail_content_item_label">所选SKU：</div>
              <div class="my_project_detail_content_item_value">
                <el-table
                    :data="originalityInfo"
                    style="width: 100%"
                    class="order_table"
                >
                  <el-table-column prop="id" label="编号" width="124" align="center">
                    <template slot-scope="scope">
                      {{scope.$index + 1}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="category_desc" label="创意类目" width="180">
                  </el-table-column>
                  <el-table-column prop="goods_name" label="创意名称" width="240">
                  </el-table-column>
                  <el-table-column prop="detail" label="描述">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" :content="scope.row.desc" placement="top">
                        <div>{{scope.row.desc}}</div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="goods_count" label="数量" width="148" align="center">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="my_project_detail_content_divider_line">

          </div>
          <div class="my_project_detail_content_label" v-show="orderInfo.order_status > 3 || orderInfo.cancel_order_status > 3">
            报名信息
          </div>
          <div class="my_project_detail_content_sign_info" v-show="orderInfo.order_status > 3 || orderInfo.cancel_order_status > 3">
            <div class="my_project_detail_content_sign_info_item">
              <span class="my_project_detail_content_sign_info_item_label">报名时间：</span>
              <span class="my_project_detail_content_sign_info_item_date">{{ serviceData.register_time_str }}</span>
            </div>
            <div class="my_project_detail_content_sign_info_item">
              <span class="my_project_detail_content_sign_info_item_label">关联案例/附件：</span>
              <span class="my_project_detail_content_sign_info_item_date">
                <el-button type="text" @click="showServiceInfo()">查看案例</el-button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <el-dialog custom-class="my_project_demand_modal" title="关联附件/案例" :visible.sync="serviceInfoVisible" width="680px" :before-close="handleClose2" :close-on-click-modal="false">
        <div class="my_project_demand_modal_list">
          <img v-if="serviceInfo.orderFiles.length == 0 && serviceInfo.orderCases.length == 0" :src="require('@/assets/img/shopping_cart_empty.png')"/>
          <p style="text-align: center" v-if="serviceInfo.orderFiles.length == 0 && serviceInfo.orderCases.length == 0">该服务商还没有关联任何案例或附件～</p>

          <div class="my_project_demand_modal_list_title" v-show="serviceInfo.orderFiles.length > 0">
            相关附件：
          </div>
          <el-table :data="serviceInfo.orderFiles" border style="width: 100%" class="my_project_demand_modal_table"  v-show="serviceInfo.orderFiles.length > 0">
            <el-table-column prop="filename" label="附件名称" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_service">
                  <el-button type="text" @click="seeOrderFile(scope.row)">{{scope.row.filename}}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="annex_desc" label="附件说明" align="center"> </el-table-column>
            <el-table-column prop="datetime" label="上传时间" align="center"> </el-table-column>
          </el-table>
          <div class="my_project_demand_modal_list_title" v-show="serviceInfo.orderCases.length > 0">
            关联案例：
          </div>
          <div class="my_project_demand_modal_list_wrap" v-show="serviceInfo.orderCases.length > 0">
            <!-- :class="index === 0 && 'my_project_demand_modal_list_item_select'" -->
            <div v-for="(item,index) in serviceInfo.orderCases" class="my_project_demand_modal_list_item" title="点击查看案例详情" :key="index" @click="seeCaseDetail(item)">
              <img :src="item.case_cover" />
              <div class="my_project_demand_modal_list_item_info">
                <div class="my_project_demand_modal_list_item_info_name">
                  <span>{{ item.name }}</span>
                  <span class="my_project_demand_modal_list_item_info_tag">{{ item.industry_top_name }}</span>
                </div>
                <div class="my_project_demand_modal_list_item_info_type">
                  {{ item.industry_second_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
import * as commfun from '@/common/common.js'
var pubPrefix = '/api'
export default {
  name: 'OrderDetail',
  components: {
    Mainl
  },
  computed: {
    formatRequirement() {
      var selfthis=this
      return selfthis.orderInfo.requirement.replace(/\n/g, '<br>');
    }
  },
  data: function () {
    return {
      orderInfo: {},
      annexData: [],  // 订单附件
      originalityInfo: [],
      serviceData: {},
      serviceInfo: {
        serviceCompany: '', // 服务商公司名
        serviceUserId: '',
        orderId: '',
        orderFiles: [],  // 关联附件
        orderCases: []   // 关联案例
      },
      serviceInfoVisible: false,
    }
  },
  mounted () {
    var queryString = window.location.search
    var urlParams = new URLSearchParams(queryString)
    var orderId = urlParams.get('order_id')
    this.orderId = orderId
    // 获取详情数据
    this.initData()
  },
  methods: {
    // 获取数据
    initData: function () {
      var selfthis = this
      var url = pubPrefix + '/api/order/demandOrderDetail'
      var postdata = {order_id: this.orderId, detail_type: 2}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.orderInfo = data
        if (data.service_data != null) {
          selfthis.serviceData = data.service_data
        }
        if (data.goods_info != null && data.goods_info.length > 0) {
          selfthis.originalityInfo = data.goods_info
        }
        if (data.annex_data != null && data.annex_data.length > 0) {
          selfthis.annexData = data.annex_data
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    handleClose2(done) {
      this.serviceInfoVisible = false
    },
    // 查看服务商信息
    showServiceInfo () {
      var selfthis = this
      selfthis.serviceInfo.serviceUserId = this.serviceData.service_userid
      console.log(this.serviceData)
      selfthis.serviceInfo.orderId = this.orderId
      selfthis.serviceInfoVisible = true
      // 查询服务方案例和附件
      var url = pubPrefix + '/api/order_material/getOrderMaterial'
      var postdata = {service_userid: this.serviceData.service_userid, order_id: this.orderId, see_type: 2}
      console.log(postdata)
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.serviceInfo.orderFiles = data.annexData
        selfthis.serviceInfo.orderCases = data.caseData
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 查看文件
    seeOrderFile (item) {
      window.open(item.url)
    },
    // 案例详情
    seeCaseDetail (item) {
      window.open('/servicecasedetail?case_id=' + item.case_id)
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/MyProjectDetail.vue